module.exports = __webpack_public_path__ + "img/64_12.714497eb.png";